import {inject, IReactComponent} from 'mobx-react';
import {SessionAbort} from './component';

import './styles.scss';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.inviteStore?.inviteFlowManager?.sessionAbortController,
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const SessionAbortComponent = inject(mapStoresToProps)(SessionAbort) as IReactComponent;

export default SessionAbortComponent;
